import { ConcreteEncodable } from "./ConcreteEncodable";

import { BlotterDefinitionListRequestImplEncoder } from "../../encoder/BlotterDefinitionListRequestImplEncoder";

import * as CubiqTS from "../../index";
import { BlotterDefinitionListRequest } from "../BlotterDefinitionListRequest";

export class BlotterDefinitionListRequestImpl
  extends ConcreteEncodable
  implements BlotterDefinitionListRequest
{
  public static enType: string = "com.bcdfx.model.event.BlotterDefinitionListRequestImpl";

  /*FID=1*/
  public blotterNames: Array<string> | null = null;
  /*FID=2*/
  public entryUserNames: Array<string> | null = null;
  /*FID=3*/
  public entryUserIds: Array<CubiqTS.Long> | null = null;
  /*FID=4*/
  public blotterTypes: Array<CubiqTS.BlotterType> | null = null;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=501*/
  public maxResponseSize: number;
  /*FID=502*/
  public maxTotalResults: number;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BlotterDefinitionListRequestImplEncoder.Instance;
    this.setEncodableType(BlotterDefinitionListRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "BlotterDefinitionListRequestImpl[" +
      "blotterNames=" +
      this.blotterNames +
      "entryUserNames=" +
      this.entryUserNames +
      "entryUserIds=" +
      this.entryUserIds +
      "blotterTypes=" +
      this.blotterTypes +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "maxResponseSize=" +
      this.maxResponseSize +
      "maxTotalResults=" +
      this.maxTotalResults +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
